'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'pen-ruler';
var width = 512;
var height = 512;
var aliases = ["pencil-ruler"];
var unicode = 'f5ae';
var svgPathData = ['M11.7 99.7c-15.6 15.6-15.6 40.9 0 56.6l69.1 69.1 144.6-144.6-34.9-34.9-56.3 56.3c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l56.3-56.3-5.9-5.9c-15.6-15.6-40.9-15.6-56.6 0l-88 88zM286.6 431.2l69.1 69.1c15.6 15.6 40.9 15.6 56.6 0l88-88c15.6-15.6 15.6-40.9 0-56.6l-5.9-5.9-56.3 56.3c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l56.3-56.3-34.9-34.9-144.6 144.6z', 'M352.9 21.2L308 66.1 445.9 204 490.8 159.1C504.4 145.6 512 127.2 512 108s-7.6-37.6-21.2-51.1L455.1 21.2C441.6 7.6 423.2 0 404 0s-37.6 7.6-51.1 21.2zM274.1 100L58.9 315.1c-10.7 10.7-18.5 24.1-22.6 38.7L.9 481.6c-2.3 8.3 0 17.3 6.2 23.4s15.1 8.5 23.4 6.2l127.8-35.5c14.6-4.1 27.9-11.8 38.7-22.6L412 237.9 274.1 100z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPenRuler = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;